<script>
    import { trainerTexts as texts } from './trainerTexts.js';
    export let lang;
    let selLang;
    export let viewOptions = {};
    export let trainerData = {};
</script>

<div class="text-zone">
    <div class="color-bar" />
    <h2 class="heading-secondary heading-secondary--darker">
        {texts[lang].log_as}
        {trainerData.email}
    </h2>
    <h3 class="heading-tertiary">{texts[lang].your_games}</h3>
    <label for="closed">
        <span class="label label--closed">{texts[lang].your_games_end}</span>
        <input
            type="checkbox"
            id="closed"
            name="closed"
            bind:checked={viewOptions.showClosed}
        />
        <span class="game__checkbox game__checkbox--closed" />
    </label>
    <label for="running">
        <span class="label label--running"
            >{texts[lang].your_games_running}</span
        >
        <input
            type="checkbox"
            id="running"
            name="running"
            bind:checked={viewOptions.showRunning}
        />
        <span class="game__checkbox game__checkbox--running" />
    </label>
    <label for="other">
        <span class="label label--other">{texts[lang].your_games_prepared}</span
        >

        <input
            type="checkbox"
            id="other"
            name="other"
            bind:checked={viewOptions.showOther}
        />
        <span class="game__checkbox game__checkbox--other" />
    </label>
    <h3 class="heading-tertiary">
        {texts[lang].licenses_left}
        {trainerData.playsLeft}
    </h3>

    <h class="heading-tertiary u-margin-top">{texts[lang].languages}</h>

    <div class="u-margin-top">
        <select
            bind:value={selLang}
            name="language"
            id="select-language"
            class="select-language"
        >
            <option value="pl" class="select-item">
                {texts[lang].languages_polish}
            </option>
            <option value="eng" class="select-item">
                {texts[lang].languages_english}
            </option>
        </select>
        <button
            class="btn btn__smaller"
            on:click|preventDefault={() => {
                lang = selLang;
            }}
        >
            {texts[lang].languages_update}
        </button>
    </div>
</div>
